import styled from "styled-components";

export const styles = {
  radarCircle: {
    fill: "none",
    stroke: "#AAAAAA", // Lightened from #333333 for better visibility
    strokeWidth: 0.8, // Increased width for better contrast
  },
  radarSectorLine: {
    stroke: "#DDDDDD", // Lightened from #444444 for better contrast
    strokeWidth: 0.8, // Increased width for better visibility
  },
  point: {
    fillOpacity: 1, // Fully opaque for brighter points
    fill: "#FF5C5C", // Bright red for better contrast
  },
  label: {
    fill: "#FFFFFF",
    fontSize: "14px", // Slightly larger for better readability
    fontWeight: "bold", // Added bold text for contrast
    textAnchor: "middle" as "middle",
  },
};

export const RightBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: absolute;
  right: 20px;
  z-index: 10;
  top: 50%;
  transform: translateY(-50%);
`;

export const ShowClastersContainer = styled.div`
  padding: 11px;
  border-radius: 8px;
  border: 1px solid;
  background-color: #272b40; // Slightly lighter for better contrast
  cursor: pointer;
`;
export const ContainerDarkeLightMode = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  border: 1px solid #4e5574;
  border-radius: 8px;
  background-color: #272b40;
  cursor: pointer;

  & div {
    width: 100%;
    height: 100%;
    padding: 11px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const SliderContainer = styled.div`
  width: 40px;
  height: 200px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid #4e5574;
  background-color: rgba(255, 255, 255, 0.2);
  justify-content: space-evenly;
  align-items: center;
`;

export const LevelIndicator = styled.div<{level: number}>`
  width: 100%;
  height: 120px;
  /* background: #e6f7ff; */
  border-radius: 8px;
  margin: 0 12px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
`;

export const LevelFill = styled.div<{level: number}>`
  width: 100%;
  height: ${({level}) => (level / 10) * 100}%;
  background: #0082ed;
  border-radius: 0 0 8px 8px;
  transition: height 0.2s;
  position: absolute;
  bottom: 0;
  left: 0;
`;

export const LupaCircle = styled.div<{disabled?: boolean}>`
  width: 20px;
  height: 20px;
  /* cursor: ${(props) => (props.disabled ? "default" : "pointer")}; */
  opacity: ${(props) => (props.disabled ? 0.4 : 0.8)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;

  /* &:hover {
    opacity: ${(props) => (props.disabled ? 0.4 : 1)};
  } */
  img {
    scale: 0.8;
    opacity: 0.6;
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
    user-drag: none;
  }
`;

export const ClickedListener = styled.div`
  cursor: grab;
  :active {
    cursor: grabbing;
  }
`;

export const VolumeControl = styled.div`
  width: 30px;
  height: 200px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
`;

export const VolumeLevel = styled.div`
  background-color: #0082ed;
  position: absolute;
  border-radius: 0 0 5px 5px;
  bottom: 0;
  width: 100%;
  transition: height 0.1s;
`;
